module.exports = __webpack_public_path__ + "img/vector pregunta.6856d9bb.png";